export default __webpack_public_path__ + "static/media/upsites_website.e8f49109.svg";